import React from 'react';
import { Modal } from 'react-bootstrap';
import { GrDocumentTxt } from 'react-icons/gr';


export default function AboutWordlistsModal({ show, onHide }) {

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header className='fw-bold purple-2-bkgd' closeButton>Wordlists on Crossworthy</Modal.Header>
      <Modal.Body style={{ fontSize: '0.9rem' }}>
        <p>
          <strong>Wordlists</strong> define what words are available to Crossworthy as it helps you fill your grid.
          Each word has a <strong>score</strong>; words with higher scores are prioritized.
        </p>

        <div className='fw-bold h6'>Creating &amp; Editing</div>
        <p>On Crossworthy, a wordlist looks something like:</p>
        <div className='d-flex justify-content-center gap-2 align-items-center text-success my-3'>
          <div className='d-flex align-items-center gap-1 mb-1 p-1 border border-success rounded-1'>
            <GrDocumentTxt />
            <span className='text-xs'>uploaded-wordlist-file.txt</span>
          </div>
          <div className='fw-bold small text-success'>+ 13 mods</div>
        </div>
        <p>This means you uploaded a wordlist file, then have made 13 changes (word additions, removals, or score changes).</p>
        <p>
          You may upload any .txt or .dict file, where each line has one word, a semicolon, and a score, like so:
        </p>
        <div className='mt-2 mb-3 text-center'>
          WORD;45
        </div>
        <p>
          White space (tabs and spaces) are ignored, and words are case-insensitive (they will be converted to all-caps).
          Any words with non-alphabetical characters (<strong>! 2 * é 心 😊</strong> etc.) will be ignored for autofill
          purposes&mdash;although you can still include these in grids using the "Rebus/Symbol" while constructing.
        </p>
        <p>
          Your original files are preserved, meaning you can create many different customizations of the same base wordlist if you like.
        </p>

        <div className='fw-bold h6'>Sharing</div>
        <p>
          Your wordlists are private unless you share them with others.
        </p>
        <p>
          If you'd like to submit/propose a wordlist to be publicly available on Crossworthy, send us an email at hello@crossworthy.net!
        </p>
      </Modal.Body>
    </Modal>
  );
}